module.exports = __webpack_public_path__ + "img/green_140.dab05ba9.png";